import { render, staticRenderFns } from "./header.vue?vue&type=template&id=621c5a44&scoped=true&"
import script from "./header.vue?vue&type=script&lang=js&"
export * from "./header.vue?vue&type=script&lang=js&"
import style0 from "./header.vue?vue&type=style&index=0&id=621c5a44&lang=scss&scoped=true&"
import style1 from "./header.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621c5a44",
  null
  
)

component.options.__file = "header.vue"
export default component.exports